import ReportDrawer from '../../../constants/ReportDrawer';
import SidebarOpen from '../../../constants/SidebarOpen';
import { useSidebar } from '../../../helpers/sidebarClose';
import CircleBtn from '../../../constants/CircleBtn';
import ReportHeader from '../../../constants/ReportHeader';
import { useReactToPrint } from "react-to-print";
import { useEffect, useRef, useState } from 'react';
import AdvancedVoucherFormView from '../../../components/account/reports/adv_voucher/AdvancedVoucherFormView';
import PrintAdvanedVoucher from '../../../components/account/reports/adv_voucher/PrintAdvanedVoucher';
import AdvancedVoucherListView from '../../../components/account/reports/adv_voucher/AdvancedVoucherListView';

const AdvancedVoucherReportCreateListView = ({ setIconsButton }: { setIconsButton: any }) => {
    const { isOpen, toggleSidebar, closeSidebar } = useSidebar('advance_voucher_rpt');
    const [onAdvVoucherReport, setOnAdvVoucherReport] = useState([]);
    const componentListRef = useRef<HTMLDivElement | null>(null);

    const handlePrintCard = useReactToPrint({
        content: () => componentListRef.current!,
    });

    useEffect(() => {
        setIconsButton(<CircleBtn onClick={handlePrintCard} />);
        return () => setIconsButton(null);
    }, []);

    useEffect(() => {
        if (!isOpen) {
            toggleSidebar();
        }
    }, [isOpen, toggleSidebar]);
    return (
        <>
            <SidebarOpen onClick={toggleSidebar} />
            <ReportDrawer header={<ReportHeader label='Advance Voucher Reports' />} open={isOpen} onClose={closeSidebar}>
                <AdvancedVoucherFormView setOnAdvVoucherReport={setOnAdvVoucherReport} />
            </ReportDrawer>
            <AdvancedVoucherListView onAdvVoucherReport={onAdvVoucherReport} />
            <div className='hidden'>
                <div ref={componentListRef}>
                    <PrintAdvanedVoucher onAdvVoucherReport={onAdvVoucherReport} />
                </div>
            </div>
        </>
    );
}

export default AdvancedVoucherReportCreateListView;
